import { IconWrapper } from '../runtime';
export default IconWrapper('three_d_model_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#5F6A72"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#8999A3"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#6F7B84"
    }
  }), h("g", {
    "attrs": {
      "clip-path": "url(#clip0_11705_25822)"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.4858 5.66491L9.19012 3.23694L3.9375 6.17208V12.1718L9.1875 15.1392L14.4375 12.1718V6.20285L13.5156 5.68177L13.5009 5.65621L13.4858 5.66491ZM11.5982 6.7518L9.18488 5.38775L6.7661 6.73935L9.20004 8.13269L11.5982 6.7518ZM5.8125 8.35395V11.0778L8.2639 12.4634V9.75729L5.8125 8.35395ZM10.1389 12.4477L12.5625 11.0778V8.36016L10.1389 9.75571V12.4477Z",
      "fill": "white"
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": "clip0_11705_25822"
    }
  }, [h("rect", {
    "attrs": {
      "width": "12.375",
      "height": "12.375",
      "fill": "white",
      "transform": "translate(3 3)"
    }
  })])])]);
});